/**
 * KAN-851: название организации клиента в приложении менеджера: ссылка на её
 * карточку /m/companies/:id, когда организация известна; иначе просто текст
 * (например, компания из lead_info). Поверх карточки-ссылки (relative z-10),
 * чтобы нажатие на название открывало организацию, а не клиента.
 */
import { Link } from 'react-router-dom';
import { mobileCompanyPath } from '@/lib/mobileApp';
import type { ClientCompanyRef } from '@/types/clientCompany';

interface MobileCompanyLinkProps {
  company: ClientCompanyRef | null | undefined;
  /** Текст без организации (и когда у организации нет названия). */
  fallback?: string | null;
  /** Размер и раскладка; цвет задаёт сам компонент (ссылка синяя, текст серый). */
  className?: string;
}

export function MobileCompanyLink({ company, fallback, className = '' }: MobileCompanyLinkProps): JSX.Element | null {
  const name = (company?.name || '').trim() || (fallback || '').trim();
  if (!name) return null;
  if (company?.id) {
    return (
      <Link
        to={mobileCompanyPath(company.id)}
        data-testid="mobile-company-link"
        className={`relative z-10 text-blue-700 underline-offset-2 active:underline ${className}`.trim()}
      >
        {name}
      </Link>
    );
  }
  return <span className={`text-gray-600 ${className}`.trim()}>{name}</span>;
}
